
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tier-list/items",
      function () {
        return require("private-next-pages/tier-list/items/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tier-list/items"])
      });
    }
  